import { ProductList, GTMProduct } from '../model';
import { GTMTrackProductImpression } from '../model/TrackingObject';

export type ProductImpressionEvent = {
    event: 'eec_impressionview';
    ecommerce: {
        categoryName?: string;
        categoryId?: string;
        categoryPath?: string;
        currencyCode?: string;
        impressions: ProductList;
    };
};

const listify = (products: GTMProduct[], impressionSource?: string): ProductList =>
    products.map((product, index) => ({
        ...product,
        position: product.position ? product.position : index,
        ...(impressionSource && { list: impressionSource }),
    }));

export const trackProductImpressionEvent = ({
    products,
    currencyCode,
    impressionSource,
    categoryName,
}: GTMTrackProductImpression): ProductImpressionEvent => ({
    event: 'eec_impressionview',
    ecommerce: {
        currencyCode,
        categoryName,
        impressions: listify(products, impressionSource),
    },
});
